// ? этот tooltip где-то исползуется?
import React from 'react';
import Portal from 'Utils/Portal/Portal';
import './tooltip.css';

export default function CardTooltip({ children, content, maxWidth = 400, position = 'top' }) {
  const [isShown, setIsShown] = React.useState(false);
  const [coords, setCoords] = React.useState({ x: 0, y: 0 });

  // const onClick = (e) => {
  //   if (!isShown) {
  //     const bounding = e.target.getBoundingClientRect();
  //     setCoords({
  //       x: bounding.x + bounding.width / 2,
  //       y: bounding.y + window.scrollY,
  //     });
  //     setIsShown(true);
  //   } else {
  //     setIsShown(false);
  //     setCoords(null);
  //   }
  // };

  const onMouseEnter = (e) => {
    const bounding = e.target.getBoundingClientRect();
    setCoords({
      x: bounding.x + bounding.width / 2,
      y: bounding.y + window.scrollY,
    });
    setIsShown(true);
  };

  // TODO: сделать потом задержку перед скрытием
  const onMouseLeave = () => {
    setCoords({ x: 0, y: 0 });
    setIsShown(false);
  };

  return (
    <>
      <span
        className="tooltip-hoverable-content"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </span>
      {isShown && (
        <Portal>
          <Wrapper
            coords={coords}
            maxWidth={maxWidth}
            position={position}
          >
            {content}
          </Wrapper>
        </Portal>
      )}
    </>
  );
}

function Wrapper({ coords, maxWidth, position, children }) {
  const ref = React.useRef();
  const [height, setHeight] = React.useState(0);
  const [width, setWidth] = React.useState(0);

  const offset = 10;

  const positions = {
    top: {
      top: coords.y - height - offset,
      left: coords.x - width / 2,
    },
    bottom: {
      top: coords.y + (offset * 2),
      left: coords.x - width / 2,
    },
    left: {
      top: coords.y - height / 2,
      left: coords.x - width - offset,
    },
    right: {
      top: coords.y - height / 2,
      left: coords.x + offset,
    },
  };

  React.useLayoutEffect(() => {
    setHeight(ref.current?.clientHeight);
    setWidth(ref.current?.clientWidth);
  }, []);

  return (
    <div
      className="tooltip-content-wrapper"
      ref={ref}
      style={{
        ...positions[position],
        maxWidth: `${maxWidth}px`,
      }}
    >
      {children}
    </div>
  );
}
